import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const PW = 210, PH = 297, M = 14, FOOT = 9;
const CW = PW - 2 * M, CH = PH - 2 * M - FOOT;
const ATOMIC = "h1,h2,h3,p,li,tr,dt,dd,figure,img,svg,.kpi,.callout,.price-card,.step,.timeline,.method,.contact,.gold-rule,.slide,.browser,.phone,.keep,.avoid-break,.sim-result,.sim-zone-box,.recap-card";
const SCALE = 2;

async function snap(el, prepare) {
  let meta = {};
  const canvas = await html2canvas(el, {
    scale: SCALE,
    useCORS: true,
    backgroundColor: "#F7F1E6",
    windowWidth: 1400,
    onclone: async (doc) => {
      const st = doc.createElement("style");
      st.textContent = "*{animation:none!important;transition:none!important}.overflow-x-auto{overflow:visible!important}img{display:inline-block!important;vertical-align:top}.strike-line{top:76%!important}.pdf-hide{display:none!important}.doc-section{padding-bottom:48px!important}.phone,.browser{box-shadow:none!important}";
      doc.head.appendChild(st);
      const c = doc.getElementById(el.id);
      if (prepare) prepare(c);
      await doc.fonts.ready;
      await new Promise((r) => setTimeout(r, 150));
      const top = c.getBoundingClientRect().top;
      meta.width = c.offsetWidth;
      meta.atoms = [...c.querySelectorAll(ATOMIC)].map((a) => {
        const r = a.getBoundingClientRect();
        const next = /^H[1-3]$/.test(a.tagName) && a.nextElementSibling;
        const bottom = next ? Math.max(r.bottom, next.getBoundingClientRect().top + Math.min(next.offsetHeight, 140)) : r.bottom;
        return [r.top - top, bottom - top];
      });
    },
  });
  return { canvas, ...meta };
}

function cutPoints(height, pageH, atoms) {
  const cuts = [];
  let y = 0;
  while (height - y > pageH) {
    const limit = y + pageH;
    const ok = atoms
      .map((a) => a[1] + 8)
      .filter((c) => c <= limit && c > y + pageH * 0.15 && !atoms.some(([t, b]) => t < c + 3 && b > c - 3));
    const end = ok.length ? Math.max(...ok) : limit;
    cuts.push([y, end]);
    y = end;
  }
  if (height - y > 60 || !cuts.length) cuts.push([y, height]);
  return cuts;
}

function slice(canvas, y0, y1) {
  const c = document.createElement("canvas");
  c.width = canvas.width;
  c.height = Math.ceil((y1 - y0) * SCALE);
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#F7F1E6";
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.drawImage(canvas, 0, -y0 * SCALE);
  return c.toDataURL("image/jpeg", 0.92);
}

function pageFrame(pdf, n) {
  pdf.setFillColor(247, 241, 230);
  pdf.rect(0, 0, PW, PH, "F");
  pdf.setDrawColor(176, 141, 87);
  pdf.setLineWidth(0.2);
  pdf.line(M, PH - M - 3, PW - M, PH - M - 3);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(7.5);
  pdf.setTextColor(107, 107, 107);
  pdf.text("BELLA NAPOLI  ·  PIANO DI SVILUPPO TECNOLOGICO E SCALABILITÀ  ·  PARTNERTECH", M, PH - M + 1);
  pdf.text(String(n), PW - M, PH - M + 1, { align: "right" });
}

export async function exportPdf(sectionIds) {
  const scrollY = window.scrollY;
  try {
    await build(sectionIds);
  } finally {
    window.scrollTo({ top: scrollY, behavior: "instant" });
  }
}

async function build(sectionIds) {
  const pdf = new jsPDF({ unit: "mm", format: "a4", compress: true });
  const cover = await snap(document.getElementById("copertina"), (c) => {
    c.style.width = "900px";
    c.style.height = "1273px";
    c.style.minHeight = "1273px";
  });
  pdf.addImage(cover.canvas.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, PW, PH);
  let page = 1;
  for (const id of sectionIds) {
    const { canvas, width, atoms } = await snap(document.getElementById(id));
    const pxPerMm = width / CW;
    const height = canvas.height / SCALE;
    for (const [y0, y1] of cutPoints(height, CH * pxPerMm, atoms)) {
      pdf.addPage();
      page += 1;
      pageFrame(pdf, page);
      pdf.addImage(slice(canvas, y0, y1), "JPEG", M, M, CW, (y1 - y0) / pxPerMm);
    }
  }
  pdf.save("Bella-Napoli_Piano-Synapse-OS_PartnerTech.pdf");
}
